export default "__VITE_ASSET__cb42c3c5__$_#icon-close__"